import {AJAX_START} from '../../constants';

export type StartRequestAction = {
    /**
     * The action type
     */
    type : typeof AJAX_START;

    /**
     * The cancelFunction from CancelToken
     */
    cancelFn : Function;

    /**
     * The uid of the component the requests belongs to
     */
    componentUid? : string;

    /**
     * The uid of the request itself
     */
    requestUid? : string;
}

/**
 * @memberOf! Actions
 *
 * @param {Function} cancelFn           The cancelFunction from CancelToken
 * @param {String} componentUid         The uid of the component the requests belongs to
 * @param {String} requestUid           The uid of the request itself
 *
 * @return {StartRequestAction}
 */
const startRequest = ( cancelFn : Function, componentUid? : string, requestUid? : string ) : StartRequestAction => {
    return {
        type: AJAX_START,
        cancelFn,
        componentUid,
        requestUid
    };
}
export type StartRequest = typeof startRequest;

export default startRequest;
